"use client";

import { Link } from "@/i18n/navigation";
import { LinkProps } from "next/link";
import { ReactNode } from "react";

interface Props extends LinkProps {
  children: ReactNode;
  className?: string;
}

const ClientLink = ({ children, className, ...props }: Props) => {
  return (
    // @ts-ignore
    <Link className={className} {...props}>
      {children}
    </Link>
  );
};

export default ClientLink;
